import React from "react";

const Java_Catch = () => {
  return (
    <div>
      <h1>Java Catch</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Catch in Java.</p>
    </div>
  );
};

export default Java_Catch;
